module.exports = __webpack_public_path__ + "static/media/20.e1eea6b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/20.svg
// module id = 141
// module chunks = 0